import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    "startTime",
    "endTime",
    "duration",
    "preview",
    "slotCount",
    "totalCount"
  ]

  connect() {
    this.updatePreview()
  }

  updatePreview() {
    const start    = this.startTimeTarget.value
    const end      = this.endTimeTarget.value
    const duration = parseInt(this.durationTarget.value)
    const levels   = this.element.querySelectorAll('input[id^="level_"]:checked').length

    if (!start || !end || !duration || levels === 0) {
      this.previewTarget.style.display = 'none'
      return
    }

    const startMins = this._toMinutes(start)
    const endMins   = this._toMinutes(end)
    const count     = Math.floor((endMins - startMins) / duration)

    if (count <= 0) {
      this.previewTarget.style.display = 'none'
      return
    }

    this.slotCountTarget.textContent  = count
    this.totalCountTarget.textContent = count * levels
    this.previewTarget.style.display  = 'block'
  }

  _toMinutes(timeStr) {
    const parts = timeStr.split(':')
    return parseInt(parts[0]) * 60 + parseInt(parts[1])
  }
}
